import httpClient from '../../configs/http-client';

interface KurlypayToken {
  // 인증토큰
  authorizationToken: string;
  // 토큰  만료시각 (yyyyMMddHHmmsssss)
  expireAt: string;
  // sha1으로 암호화된 가맹점ID
  merchantIdentifier: string;
  // sha1으로 암호화된 회원번호
  merchantMemberIdentifier: string;
}

// 컬리페이 인증 토큰 생성
export const fetchKurlypayToken = async (): Promise<KurlypayToken> => {
  const url = '/order/v1/kurlypay/authorization';
  const { data } = await httpClient.get<KurlypayToken>(url);
  return data;
};
